import React, { useEffect, useState, useRef } from 'react';
import { DropletIcon, InfoIcon, AlertTriangleIcon, PackageIcon, ClockIcon, XIcon, ArrowRightIcon } from 'lucide-react';
import { trackPurchaseClick, trackSectionView, trackPopupInteraction, trackContentEngagement } from './MetaPixelTracker';
export function ProductDetails() {
  const [activePopup, setActivePopup] = useState<string | null>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Track section view when component mounts
    trackSectionView('ProductDetails');
  }, []);
  const togglePopup = (popupName: string) => {
    if (activePopup === popupName) {
      setActivePopup(null);
      trackPopupInteraction(popupName, 'close');
    } else {
      setActivePopup(popupName);
      trackPopupInteraction(popupName, 'open');
    }
  };
  const closePopup = () => {
    if (activePopup) {
      trackPopupInteraction(activePopup, 'close');
      setActivePopup(null);
    }
  };
  // Content for each popup
  const popupContent = {
    terms: <div data-id="element-367">
        <h4 className="text-lg font-bold mb-2" data-id="element-368">Términos y Condiciones</h4>
        <p className="mb-2" data-id="element-369">
          Al adquirir ImpulseX, aceptas los siguientes términos:
        </p>
        <ul className="list-disc pl-5 mb-2" data-id="element-370">
          <li data-id="element-371">El producto es para uso personal únicamente.</li>
          <li data-id="element-372">No se aceptan devoluciones una vez abierto el producto.</li>
          <li data-id="element-373">Debes ser mayor de 18 años para adquirir este producto.</li>
          <li data-id="element-374">No nos hacemos responsables por el mal uso del producto.</li>
        </ul>
      </div>,
    privacy: <div data-id="element-375">
        <h4 className="text-lg font-bold mb-2" data-id="element-376">Política de Privacidad</h4>
        <p className="mb-2" data-id="element-377">Tu privacidad es importante para nosotros:</p>
        <ul className="list-disc pl-5 mb-2" data-id="element-378">
          <li data-id="element-379">Tus datos personales están seguros y encriptados.</li>
          <li data-id="element-380">No compartimos tu información con terceros.</li>
          <li data-id="element-381">
            El envío se realiza en paquetes discretos sin marcas del producto.
          </li>
          <li data-id="element-382">Tu historial de compras es confidencial.</li>
        </ul>
      </div>,
    faq: <div data-id="element-383">
        <h4 className="text-lg font-bold mb-2" data-id="element-384">Preguntas Frecuentes</h4>
        <div className="space-y-3" data-id="element-385">
          <div data-id="element-386">
            <p className="font-semibold" data-id="element-387">¿Cuánto dura el efecto?</p>
            <p data-id="element-388">Cada toma dura aproximadamente 24 horas.</p>
          </div>
          <div data-id="element-389">
            <p className="font-semibold" data-id="element-390">¿Tiene efectos secundarios?</p>
            <p data-id="element-391">
              No se han reportado efectos secundarios significativos cuando se
              usa según las indicaciones.
            </p>
          </div>
          <div data-id="element-392">
            <p className="font-semibold" data-id="element-393">¿Cuánto tarda en hacer efecto?</p>
            <p data-id="element-394">
              Se recomienda tomar 40 minutos antes de la actividad para mejores
              resultados.
            </p>
          </div>
        </div>
      </div>,
    contact: <div data-id="element-395">
        <h4 className="text-lg font-bold mb-2" data-id="element-396">Contacto</h4>
        <p className="mb-2" data-id="element-397">Estamos aquí para ayudarte:</p>
        <ul className="space-y-2" data-id="element-398">
          <li data-id="element-399">
            <strong data-id="element-400">Email:</strong> soporte@impulsex.com
          </li>
          <li data-id="element-401">
            <strong data-id="element-402">WhatsApp:</strong> +54 9 11 1234-5678
          </li>
          <li data-id="element-403">
            <strong data-id="element-404">Horario:</strong> Lunes a Viernes, 9:00 - 18:00
          </li>
        </ul>
      </div>
  };
  return <section className="py-16" data-id="element-405">
      <div className="max-w-3xl mx-auto" data-id="element-406">
        <h2 className="text-2xl font-bold mb-8 text-center" data-id="element-407">
          <span className="bg-gradient-to-r from-red-500 to-orange-500 text-transparent bg-clip-text" data-id="element-408">
            DETALLES DEL PRODUCTO
          </span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-409">
          <div className="bg-gray-900 rounded-lg p-6 border border-gray-800" onClick={() => trackContentEngagement('product_details', 'left_panel', 'view')} data-id="element-410">
            <div className="flex items-start mb-4" data-id="element-411">
              <PackageIcon className="h-5 w-5 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-412" />
              <div data-id="element-413">
                <h3 className="font-bold text-lg" data-id="element-414">Nombre</h3>
                <p className="text-gray-300" data-id="element-415">ImpulseX – Gotero 30ml</p>
              </div>
            </div>
            <div className="flex items-start mb-4" data-id="element-416">
              <DropletIcon className="h-5 w-5 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-417" />
              <div data-id="element-418">
                <h3 className="font-bold text-lg" data-id="element-419">Uso recomendado</h3>
                <p className="text-gray-300" data-id="element-420">10ml 40min antes de la accion</p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-421">
              <InfoIcon className="h-5 w-5 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-422" />
              <div data-id="element-423">
                <h3 className="font-bold text-lg" data-id="element-424">Ingredientes</h3>
                <p className="text-gray-300" data-id="element-425">
                  Cada gota combina el poder de la miel cruda con el rugido
                  ancestral del Tongkat Ali…La chispa del Guaraná… y la calidez
                  penetrante de la Canela Sagrada. Todo, sincronizado para
                  despertar al animal dormido en vos.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-900 rounded-lg p-6 border border-gray-800" onClick={() => trackContentEngagement('product_details', 'right_panel', 'view')} data-id="element-426">
            <div className="flex items-start mb-4" data-id="element-427">
              <ClockIcon className="h-5 w-5 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-428" />
              <div data-id="element-429">
                <h3 className="font-bold text-lg" data-id="element-430">Duración estimada</h3>
                <p className="text-gray-300" data-id="element-431">
                  cada toma 24h (Frasco 3 tomadas)
                </p>
              </div>
            </div>
            <div className="flex items-start mb-4" data-id="element-432">
              <AlertTriangleIcon className="h-5 w-5 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-433" />
              <div data-id="element-434">
                <h3 className="font-bold text-lg" data-id="element-435">Advertencias</h3>
                <p className="text-gray-300" data-id="element-436">
                  No apto para menores de 18 años. No usar en embarazo o
                  lactancia.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-437">
              <PackageIcon className="h-5 w-5 text-red-500 mr-3 mt-1 flex-shrink-0" data-id="element-438" />
              <div data-id="element-439">
                <h3 className="font-bold text-lg" data-id="element-440">Origen</h3>
                <p className="text-gray-300" data-id="element-441">Fórmula original importada</p>
              </div>
            </div>
          </div>
        </div>
        {/* CTA Button */}
        <div className="mt-16 mb-10" data-id="element-442">
          
        </div>
      </div>
      {/* Footer Section */}
      <footer className="mt-20 pt-10 border-t border-gray-800" data-id="element-443">
        <div className="max-w-3xl mx-auto px-4" data-id="element-444">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-445">
            <div data-id="element-446">
              <h3 className="text-lg font-bold text-white mb-4" data-id="element-447">ImpulseX</h3>
              <p className="text-gray-400 text-sm" data-id="element-448">
                Activación masculina natural con fórmula ancestral mejorada con
                ciencia moderna.
              </p>
            </div>
            <div className="relative" ref={popupRef} data-id="element-449">
              <h3 className="text-lg font-bold text-white mb-4" data-id="element-450">Enlaces</h3>
              <ul className="space-y-2 text-sm" data-id="element-451">
                <li data-id="element-452">
                  <button onClick={() => togglePopup('terms')} className="text-gray-400 hover:text-red-500 transition text-left" data-id="element-453">
                    Términos y Condiciones
                  </button>
                </li>
                <li data-id="element-454">
                  <button onClick={() => togglePopup('privacy')} className="text-gray-400 hover:text-red-500 transition text-left" data-id="element-455">
                    Política de Privacidad
                  </button>
                </li>
                <li data-id="element-456">
                  <button onClick={() => togglePopup('faq')} className="text-gray-400 hover:text-red-500 transition text-left" data-id="element-457">
                    Preguntas Frecuentes
                  </button>
                </li>
              </ul>
              {/* Positioned popup */}
              {activePopup && <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center" onClick={closePopup} data-id="element-458">
                  <div className="bg-gray-800 border border-gray-700 rounded-lg p-4 shadow-lg max-w-md w-full mx-4" onClick={e => e.stopPropagation()} data-id="element-459">
                    <button onClick={closePopup} className="absolute top-2 right-2 text-gray-400 hover:text-red-500" data-id="element-460">
                      <XIcon className="h-4 w-4" data-id="element-461" />
                    </button>
                    {popupContent[activePopup as keyof typeof popupContent]}
                  </div>
                </div>}
            </div>
          </div>
          <div className="text-center py-6 border-t border-gray-800" data-id="element-462">
            <p className="text-gray-500 text-sm" data-id="element-463">
              © {new Date().getFullYear()} ImpulseX. Todos los derechos
              reservados.
            </p>
          </div>
        </div>
      </footer>
    </section>;
}